// Core
import React from 'react';
import { useSelector } from 'react-redux';
// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import StatsLoader from '../../../components/StatsLoader';
import graphColours from 'constants/graphColours';
import StatsLogic from '../../../Logic/StatsLogic';

const ResolvedConversations = (props) => {
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingBotResolvedConversations
  );

  let totalUnresolvedConversations = 0;
  let totalResolvedConversations = 0;
  let totalConversations = 0;
  const getStatDate = (stat) => stat.day;
  // Gets Conversation Amounts based on the date ranges.
  const data = StatsLogic.aggregateStatsByRange(
    props.botsResolvedConversations,
    props.currentPeriod,
    (conversations) => {
      const conversationCount = conversations.reduce(
        ([resolvedConversations, unresolvedConversations], conversation) => {
          // update header values
          totalResolvedConversations += conversation.resolved_conversations;
          totalUnresolvedConversations += conversation.unresolved_conversations;

          return [
            (resolvedConversations += conversation.resolved_conversations),
            (unresolvedConversations += conversation.unresolved_conversations),
          ];
        },
        [0, 0]
      );
      return conversationCount;
    },
    getStatDate
  );

  const header = ['date', 'Resolved Conversations', 'Passed to Human'];
  const graphData = [header, ...data];
  const graphOptions = {
    hAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: '',
      minValue: 0,
      slantedText: true,
      slantedTextAngle: StatsLogic.getSlantedTextAngleForRange(
        props.currentPeriod
      ),
      gridlines: {
        color: '#CBD5E1',
      },
      baselineColor: '#CBD5E1',
    },
    vAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: 'Conversations',
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: {
        color: '#CBD5E1',
        count: -1
      },
      baselineColor: '#CBD5E1',
    },
    isStacked: true,
    legend: { 
      position: 'top', 
      textStyle: { fontName: 'Satoshi-Gecko', fontSize: 13, italic: false, color: '#172554' } 
    },
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary, graphColours.secondary],
  };
  totalConversations =
    totalResolvedConversations + totalUnresolvedConversations;

  const headerText =
    totalConversations > 0
      ? `${((totalResolvedConversations / totalConversations) * 100).toFixed(
          0
        )}%`
      : '0%';
  const unit = `out of ${totalConversations} conversations were successful`;
  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={headerText}
              suffix={<span style={{ fontSize: '14px' }}>{unit}</span>}
              showSecondary={false}
            />
          </div>
        </GeckoRow>
        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={graphOptions}
              graph_id={graphData.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default ResolvedConversations;
